import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RequireAuth from "./RequireAuth";
/** Components Import */
import Login from "../Factories/Account/Login";
import DrawerScreen from "./Drawer";
// import NotFound from "./pages/NotFound";
import Home from "../Factories/Home/Home";
import BM10010 from "../Factories/Bases/BM10010";
import BM10020 from "../Factories/Bases/BM10020";
import BM10030 from "../Factories/Bases/BM10030";
import BM10040 from "../Factories/Bases/BM10040";
import BM10050 from "../Factories/Bases/BM10050";
import BM10060 from "../Factories/Bases/BM10060";
import BM10070 from "../Factories/Bases/BM10070";
import BM10080 from "../Factories/Bases/BM10080";
import BM10090 from "../Factories/Bases/BM10090";
import BM10100 from "../Factories/Bases/BM10100";
import BM10110 from "../Factories/Bases/BM10110";
import BM10120 from "../Factories/Bases/BM10120";
import SM10010 from "../Factories/Sales/SM10010";
import SM10020 from "../Factories/Sales/SM10020";
import SM10030 from "../Factories/Sales/SM10030";
import SM10040 from "../Factories/Sales/SM10040";
import SM10050 from "../Factories/Sales/SM10050";
import SM10060 from "../Factories/Sales/SM10060";
import PM10010 from "../Factories/Purchase/PM10010";
import PM10020 from "../Factories/Purchase/PM10020";
import PM10030 from "../Factories/Purchase/PM10030";
import PM10040 from "../Factories/Purchase/PM10040";
import MM10010 from "../Factories/Manufacture/MM10010";
import MM10020 from "../Factories/Manufacture/MM10020";
import MM10030 from "../Factories/Manufacture/MM10030";
import MM10040 from "../Factories/Manufacture/MM10040";
import MM10050 from "../Factories/Manufacture/MM10050";
import MM10060 from "../Factories/Manufacture/MM10060";
import MM10070 from "../Factories/Manufacture/MM10070";
import MM10080 from "../Factories/Manufacture/MM10080";
import ST10010 from "../Factories/Stock/ST10010";
import ST10020 from "../Factories/Stock/ST10020";
import ST10030 from "../Factories/Stock/ST10030";
import ST10040 from "../Factories/Stock/ST10040";
import ST10050 from "../Factories/Stock/ST10050";
import ST10060 from "../Factories/Stock/ST10060";
import DB10010 from "../Factories/DashBoard/DB10010";
import DB10020 from "../Factories/DashBoard/DB10020";
import DB10030 from "../Factories/DashBoard/DB10030";
import DB10040 from "../Factories/DashBoard/DB10040";

export default function Routers() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Login />
            </RequireAuth>
          }
        />
        <Route
          element={
            <RequireAuth>
              <DrawerScreen />
            </RequireAuth>
          }
        >
          <Route path="Home" element={<Home />} />
          <Route path="BaseManagement">
            <Route path="/BaseManagement/BM10010" element={<BM10010 />} />
            <Route path="/BaseManagement/BM10020" element={<BM10020 />} />
            <Route path="/BaseManagement/BM10030" element={<BM10030 />} />
            <Route path="/BaseManagement/BM10040" element={<BM10040 />} />
            <Route path="/BaseManagement/BM10050" element={<BM10050 />} />
            <Route path="/BaseManagement/BM10060" element={<BM10060 />} />
            <Route path="/BaseManagement/BM10070" element={<BM10070 />} />
            <Route path="/BaseManagement/BM10080" element={<BM10080 />} />
            <Route path="/BaseManagement/BM10090" element={<BM10090 />} />
            <Route path="/BaseManagement/BM10100" element={<BM10100 />} />
            <Route path="/BaseManagement/BM10110" element={<BM10110 />} />
            <Route path="/BaseManagement/BM10120" element={<BM10120 />} />
          </Route>
          <Route path="SalesManagement">
            <Route path="/SalesManagement/SM10010" element={<SM10010 />} />
            <Route path="/SalesManagement/SM10020" element={<SM10020 />} />
            <Route path="/SalesManagement/SM10030" element={<SM10030 />} />
            <Route path="/SalesManagement/SM10040" element={<SM10040 />} />
            <Route path="/SalesManagement/SM10050" element={<SM10050 />} />
            <Route path="/SalesManagement/SM10060" element={<SM10060 />} />
          </Route>
          <Route path="ScheduleManagement"></Route>
          <Route path="PurchaseManagement">
            <Route path="/PurchaseManagement/PM10010" element={<PM10010 />} />
            <Route path="/PurchaseManagement/PM10020" element={<PM10020 />} />
            <Route path="/PurchaseManagement/PM10030" element={<PM10030 />} />
            <Route path="/PurchaseManagement/PM10040" element={<PM10040 />} />
          </Route>
          <Route path="ManufactureManagement">
            <Route
              path="/ManufactureManagement/MM10010"
              element={<MM10010 />}
            />
            <Route
              path="/ManufactureManagement/MM10020"
              element={<MM10020 />}
            />
            <Route
              path="/ManufactureManagement/MM10030"
              element={<MM10030 />}
            />
            <Route
              path="/ManufactureManagement/MM10040"
              element={<MM10040 />}
            />
            <Route
              path="/ManufactureManagement/MM10050"
              element={<MM10050 />}
            />
            <Route
              path="/ManufactureManagement/MM10060"
              element={<MM10060 />}
            />
            <Route
              path="/ManufactureManagement/MM10070"
              element={<MM10070 />}
            />
            <Route
              path="/ManufactureManagement/MM10080"
              element={<MM10080 />}
            />
          </Route>
          <Route path="StockManagement">
            <Route path="/StockManagement/ST10010" element={<ST10010 />} />{" "}
            <Route path="/StockManagement/ST10020" element={<ST10020 />} />
            <Route path="/StockManagement/ST10030" element={<ST10030 />} />
            <Route path="/StockManagement/ST10040" element={<ST10040 />} />
            <Route path="/StockManagement/ST10050" element={<ST10050 />} />{" "}
            <Route path="/StockManagement/ST10060" element={<ST10060 />} />
          </Route>
          <Route path="DashboardManagement">
            <Route path="/DashboardManagement/DB10010" element={<DB10010 />} />
            <Route
              path="/DashboardManagement/DB10020"
              element={<DB10020 />}
            />{" "}
            <Route path="/DashboardManagement/DB10030" element={<DB10030 />} />
            {/* <Route path="/DashboardManagement/DB10040" element={<DB10040 />} /> */}
          </Route>
        </Route>
        {/* <Route path="*" component={NotFound} /> */}
      </Routes>
    </BrowserRouter>
  );
}
